import React, { useState } from 'react'
import ReportTable from '../../components/reports/table'
import { ReportControls, DisplayToggle } from './report-controls'
import { ILeaveBalanceMonthlyReportProps } from './types'
import { getColumnsWithMonths, getMonthKey } from '@vacationtracker/shared/functions/export'
import { leaveBalanceMonthylReportColumns } from '@vacationtracker/shared/types/export'

const LeaveBalanceMonthlyReport: React.FC<ILeaveBalanceMonthlyReportProps> = ({
  companyData,
  data,
  total,
  page,
  loading,
  display,
  defaultFilters,
  onFiltersChange,
  onDisplayChange,
  loadNext,
  loadPrevious,
  download,
}) => {
  const [hideEmptyColumns, setHideEmptyColumns] = useState<boolean>(() => {
    const stored = localStorage.getItem('monthly-leave-balance-report_hideEmptyColumns')
    if (stored !== null) return stored === 'true'
    localStorage.setItem('monthly-leave-balance-report_hideEmptyColumns', 'true')
    return true
  })

  const handleHideEmptyColumnsChange = (value: boolean) => {
    setHideEmptyColumns(value)
    localStorage.setItem('monthly-leave-balance-report_hideEmptyColumns', String(value))
  }

  const formatMonthlyColumnValues = (data) => {
    data.forEach((item) => {
      item.amount.forEach((amount) => {
        const key = getMonthKey(amount.month as number, amount.year as number)
        item[key] = { days: 0, hours: 0, raw: { days: amount.raw.days, hours: amount.raw.hours } }
      })
    })
    return data
  }

  return (
    <div>
      <ReportControls
        show={<DisplayToggle value={display} onChange={onDisplayChange} />}
        companyData={companyData}
        defaultFilters={defaultFilters}
        onFiltersChange={onFiltersChange}
      />
      <ReportTable
        columnNames={getColumnsWithMonths(leaveBalanceMonthylReportColumns)}
        data={formatMonthlyColumnValues(data)}
        total={total}
        loadNext={loadNext}
        loadPrevious={loadPrevious}
        download={download}
        loading={loading}
        dateFormat={'YYYY-MM-DD'}
        display={display}
        page={page}
        reportType="monthly-leave-balance-report"
        editableColumns={true}
        hideEmptyColumns={hideEmptyColumns}
        onHideEmptyColumnsChange={handleHideEmptyColumnsChange}
      />
    </div>
  )
}

export default LeaveBalanceMonthlyReport
